module.exports = __webpack_public_path__ + "static/media/jumbo2.de0ea742.png";